{
    "generic": "Se ha producido un error. Inténtelo de nuevo.",
    "notFound": "No hemos encontrado lo que estaba buscando."
}
